import React from 'react'
import TrustedByBlock from './TrustedByBlock'
import createMarkup from './common/createMarkup'
import { baseUrl } from 'utils/parseDomain'
import 'styles/footerCopyContent.scss'

const navigationLinks = [
  { link: 'india-matrimony', anchorTag: 'India' },
  { link: 'usa-nri-matrimony', anchorTag: 'USA' },
  { link: 'canada-nri-matrimony', anchorTag: 'Canada' },
  { link: 'united-kingdom-nri-matrimony', anchorTag: 'UK' },
  { link: 'singapore-nri-matrimony', anchorTag: 'Singapore' },
  { link: 'australia-nri-matrimony', anchorTag: 'Australia' },
  { link: 'united-arab-emirates-nri-matrimony', anchorTag: 'UAE' },
]

const RenderNavigationLinks = ({ prependUrl, arrLinks }) => {
  return arrLinks.map(linkData => (
    <li key={Math.random()}>
      <a href={`${prependUrl}${linkData.link}`}>{linkData.anchorTag}</a>
    </li>
  ))
}

function FooterCopyContent(props) {
  return (
    <div className="container">
      <div className="sRedLogo" />
      <div className="contentCopy">
        <span dangerouslySetInnerHTML={createMarkup(props.footerText)} />
        {` `}
        <a href={`${baseUrl}/introduction/index/letter-from-cmd`}>
          Learn more
          <span className="rightArrow" />
        </a>
      </div>
      <div className="col-xs-12">
        <ul className="contentNavigation">
          <RenderNavigationLinks
            prependUrl={`${baseUrl}/matrimony/`}
            arrLinks={navigationLinks}
          />
          <li>
            <a
              href={`${baseUrl}/matrimonials/countries`}
              rel="noopener noreferrer"
              target="_blank"
            >
              NRI Matrimonials
              <span className="rightArrow" />
            </a>
          </li>
        </ul>
      </div>
      <TrustedByBlock />
    </div>
  )
}

export default FooterCopyContent
